import { render, staticRenderFns } from "./ImprimirProcesada.vue?vue&type=template&id=6701dc6f&scoped=true&"
import script from "./ImprimirProcesada.vue?vue&type=script&lang=js&"
export * from "./ImprimirProcesada.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirProcesada.vue?vue&type=style&index=0&id=6701dc6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6701dc6f",
  null
  
)

export default component.exports